// extracted by mini-css-extract-plugin
module.exports = {"formRoot":"SwitchBtn_formRoot__3vfxf","label":"SwitchBtn_label__3ynDe","cursorDefault":"SwitchBtn_cursorDefault__aLm2O","switchWrapper":"SwitchBtn_switchWrapper__B-edU"};